import { Loading } from 'components/common/Loading'
import React from 'react'

const LoadingModal = ({ whiteBackground }) => {
  return (
    <div
      className={`flex justify-center items-center fixed top-0 left-0 w-[100vw] h-[100vh] z-[5000] ${
        whiteBackground ? 'bg-[#ededed]' : 'bg-[#00000022]'
      }`}
    >
      <Loading />
    </div>
  )
}

export default LoadingModal
